import { $authHost, $host } from ".";
import { jwtDecode } from "jwt-decode";

export const signin = async (login, password) => {
    const response = await $host.post('/apig/auth/login', { login, password })
    const data = response.data
    localStorage.setItem('token', data.accessToken)
    return jwtDecode(data.accessToken)
}

export const check = async () => {
    const { data } = await $authHost.get('/apig/auth/check')
    localStorage.setItem('token', data.accessToken)
    return jwtDecode(data.accessToken)
}

// export const login = () => {
//     window.location.href = 'http://localhost:6500/apig/auth/login';
// };

// export const logout = async () => {
//     await $authHost.get('/auth/logout');
// };

// export const check = async () => {
//     const { data } = await $authHost.get('/apig/auth/me')
//     console.log(data)
//     // localStorage.setItem('token', data.accessToken)
//     // return jwtDecode(data.accessToken)
// }

// Пользователи
export const getUsers = async () => {
    try {
        const { data } = await $authHost.get('/apig/users')
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Получить пользователей с ролями в заданном проекте
export const getUsersByProject = async (projectId) => {
    try {
        const { data } = await $authHost.get(`/apig/users/project/${projectId}`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Создание пользователей отключено - пользователи добавляются через внешнюю систему
// export const addUser = async (user) => {
//     try {
//         const { data } = await $authHost.post('/apig/users', user)
//         return data
//     } catch (e) {
//         console.log(e)
//         throw e
//     }
// }

export const editUser = async (id, user) => {
    try {
        const { data } = await $authHost.put(`/apig/users/${id}`, user)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Обновить привязку пользователя к VIO
export const updateUserVioLink = async (id, vio_id) => {
    try {
        const { data } = await $authHost.put(`/apig/users/${id}/vio-link`, { vio_id })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Получить пользователей VIO
export const getVioUsers = async () => {
    try {
        const { data } = await $authHost.get('/apig/state/vio-users')
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Получить пользователей Telegram
export const getTelegramUsers = async () => {
    try {
        const { data } = await $authHost.get('/apig/state/telegram-users')
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Обновить привязку пользователя к Telegram
export const updateUserTelegramLink = async (id, telegram_id) => {
    try {
        const { data } = await $authHost.put(`/apig/users/${id}/telegram-link`, { telegram_id })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Удаление пользователей отключено - пользователи управляются через внешнюю систему
// export const deleteUser = async (id) => {
//     try {
//         const { data } = await $authHost.delete(`/apig/users/${id}`)
//         return data
//     } catch (e) {
//         console.log(e)
//         throw e
//     }
// }

// Роли
export const getRoles = async () => {
    try {
        const { data } = await $authHost.get('/apig/roles')
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const addRole = async (role) => {
    try {
        const { data } = await $authHost.post('/apig/roles', role)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const editRole = async (id, role) => {
    try {
        const { data } = await $authHost.put(`/apig/roles/${id}`, role)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const deleteRole = async (id) => {
    try {
        const { data } = await $authHost.delete(`/apig/roles/${id}`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Роли пользователей
export const getUserRoles = async (userId) => {
    try {
        const { data } = await $authHost.get(`/apig/users/${userId}/roles`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const addRoleToUser = async (userId, roleId) => {
    try {
        const { data } = await $authHost.post(`/apig/users/${userId}/roles`, { role_id: roleId })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const removeRoleFromUser = async (userId, roleId) => {
    try {
        const { data } = await $authHost.delete(`/apig/users/${userId}/roles/${roleId}`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Проекты
export const getProjects = async () => {
    try {
        const { data } = await $authHost.get('/apig/projects')
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const getProject = async (id) => {
    try {
        const { data } = await $authHost.get(`/apig/projects/${id}`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Управление проектами отключено - проекты создаются администратором
// export const addProject = async (project) => {
//     try {
//         const { data } = await $authHost.post('/apig/projects', project)
//         return data
//     } catch (e) {
//         console.log(e)
//         throw e
//     }
// }

// export const editProject = async (id, project) => {
//     try {
//         const { data } = await $authHost.put(`/apig/projects/${id}`, project)
//         return data
//     } catch (e) {
//         console.log(e)
//         throw e
//     }
// }

// export const deleteProject = async (id) => {
//     try {
//         const { data } = await $authHost.delete(`/apig/projects/${id}`)
//         return data
//     } catch (e) {
//         console.log(e)
//         throw e
//     }
// }

// Задачи
export const getTasks = async (filters = {}) => {
    try {
        const { data } = await $authHost.get('/apig/tasks', { params: filters })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const getTask = async (id) => {
    try {
        const { data } = await $authHost.get(`/apig/tasks/${id}`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const addTask = async (task) => {
    try {
        const { data } = await $authHost.post('/apig/tasks', task)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const editTask = async (id, task) => {
    try {
        const { data } = await $authHost.put(`/apig/tasks/${id}`, task)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const deleteTask = async (id, reason, archived_by_id) => {
    try {
        const { data } = await $authHost.delete(`/apig/tasks/${id}`, { 
            data: { reason, archived_by_id }
        })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const getArchivedTasks = async (filters = {}) => {
    try {
        const { data } = await $authHost.get('/apig/archive', { params: filters })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

// Планы
export const getNewPlanId = async () => {
    try {
        const { data } = await $authHost.get('/apig/tasks/newPlanId')
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const validatePlanId = async (userId, planId) => {
    try {
        const { data } = await $authHost.get(`/apig/tasks/validatePlanId/${userId}/${planId}`)
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

export const getPointsTasks = async (statuses = []) => {
    try {
        const params = statuses.length > 0 ? { statuses: Array.isArray(statuses) ? statuses.join(',') : statuses } : {};
        const { data } = await $authHost.get('/apig/tasks/points', { params })
        return data
    } catch (e) {
        console.log(e)
        throw e
    }
}

